import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { init } from "@sentry/angular";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

if (environment.sentryDsn) {
  init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment || undefined,
    tracesSampleRate: environment.sentryTracesSampleRate || 0,
    sendDefaultPii: false,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      /Loading chunk \d+ failed/,
      "Script error.",
      "AbortError",
      "Non-Error promise rejection captured",
    ],
    denyUrls: [
      /^chrome-extension:\/\//,
      /^moz-extension:\/\//,
      /^safari(-web)?-extension:\/\//,
      /translate\.googleapis\.com/,
    ],
  });
}
